import classNames from 'classnames';
import {
	ApkAssignmentContext,
	IApkAssignmentContext,
} from 'modules/FirmwareAndApp/Apk/ApkAssignment/apkAssignmentState/apkAssignmentContext';
import React, { useContext, useEffect } from 'react';
import CustomerCrumb from './components/CustomerCrumb';
import RestaurantCrumb from './components/RestaurantCrumb';
import ApkCrumb from './components/ApkCrumb';
import style from './Breadcrumbs.module.scss';

const Breadcrumbs: React.FC = () => {
	const { setShowBreadcrumbs, isShowBreadcrumbs, IDsSelectedCustomers } =
		useContext<IApkAssignmentContext>(ApkAssignmentContext);

	const containerClasses = classNames(style.container, { [style.hidden]: !isShowBreadcrumbs });

	const emptyCustomers = !Object.keys(IDsSelectedCustomers).length;

	useEffect(() => {
		emptyCustomers && setShowBreadcrumbs(false);
	}, [emptyCustomers]);

	return (
		<div className={containerClasses} data-test="Breadcrumbs">
			<CustomerCrumb />
			<RestaurantCrumb />
			<ApkCrumb />
		</div>
	);
};

export default Breadcrumbs;
